if (!customElements.get('header-bar')) {
  class HeaderBar extends HTMLElement {
    connectedCallback() {
      try {
        if (typeof getCookie === 'function' && getCookie('header-bar-hidden')) {
          this.classList.add('hidden');
        }
      } catch (e) {
        // If cookie helpers are missing, do nothing (bar stays visible)
      }

      this.closeBtn = this.querySelector('[header-bar="close"]');
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => {
          this.classList.add('hidden');
          try {
            if (typeof setCookie === 'function') setCookie('header-bar-hidden', 'true', 30);
          } catch (e) {}
        });
      }
    }
  }
  customElements.define('header-bar', HeaderBar);
}